import { ApiClient, DayApi, TrackApi, IDay, IDaysResponse, ITracksResponse, ITrip } from "../../Types"

// The data-access object for TripView, extracted so the root stays a thin composer and
// the wire-contract tests (TripView.Data.test) keep full coverage. Re-exported from
// Views/TripView so external importers and the flat data test are unchanged.
export const TripViewData = {
  loadDays(api: ApiClient, shipId: number, tripId: number): Promise<IDaysResponse> {
    return new DayApi(api).days.list({ params: { shipId, tripId } }).call();
  },
  loadTrack(api: ApiClient, shipId: number, tripId: number): Promise<ITracksResponse> {
    return new TrackApi(api).tracks.trip({ params: { shipId, tripId } }).call();
  },
  // Expand a sparse, ascending day list into a contiguous one by inserting synthetic
  // blank days (id 0) for every missing day between recorded days. Days numbered < 1
  // are skipped. Returns undefined when there are no days yet (still loading).
  fillDayGaps(days: IDay[] | undefined, trip: ITrip): IDay[] | undefined {
    if (!days) {
      return;
    }
    const result: IDay[] = [];
    let last: number | null = null;
    for (const day of days) {
      if (day.day < 1) {
        continue;
      }
      if (last && last < day.day - 1) {
        for (let d = last + 1; d < day.day; d++) {
          result.push({ id: 0, cruiseId: trip.cruiseId, tripId: trip.id, accountId: trip.accountId, shipId: trip.shipId, createdAt: day.createdAt, updatedAt: day.updatedAt, day: d, timezone: day.timezone, data: "{}" });
        }
      }
      result.push(day);
      last = day.day;
    }
    return result;
  },

  // Start/end passage location for a trip, shared by the interactive TripView header and
  // Print/TripsView. Both read the calculated locations with an empty-string fallback;
  // keeping this in one place stops the two headers from drifting.
  tripLocations(trip: ITrip): { startLocation: string; endLocation: string } {
    const calculated = trip.calculated;
    return {
      startLocation: calculated?.startLocation || "",
      endLocation: calculated?.endLocation || "",
    };
  },
};
